import {
  CRUD_CAMPAIGN_CRM_TEAM,
  GET_CAMPAIGN_CRM_TEAM_BY_CAMPAIGN_ID,
  CRUD_INQUIRY_CRM_TEAM,
  GET_INQUIRY_CRM_TEAM_BY_INQUIRY_ID,
  CRUD_LEAD_CRM_TEAM,
  GET_LEAD_CRM_TEAM_BY_LEAD_ID,
  CRUD_PROSPECT_CRM_TEAM,
  GET_PROSPECT_CRM_TEAM_BY_PROSPECT_ID,
  CRUD_OPPORTUNITY_CRM_TEAM,
  GET_OPPORTUNITY_CRM_TEAM_BY_OPPORTUNITY_ID,
  CRUD_CONTACT_CRM_TEAM,
  GET_CONTACT_CRM_TEAM_BY_CONTACT_ID,
  CRUD_ACCOUNT_CRM_TEAM,
  GET_ACCOUNT_CRM_TEAM_BY_ACCOUNT_ID,
  CRUD_CUSTOMER_CRM_TEAM,
  GET_CUSTOMER_CRM_TEAM_BY_CUSTOMER_ID,
  CRUD_CONTRACT_CRM_TEAM,
  GET_CONTRACT_CRM_TEAM_BY_CONTRACT_ID,
  CRUD_ORDER_CRM_TEAM,
  GET_ORDER_CRM_TEAM_BY_ORDER_ID,
  CRUD_CRM_TEAM,
} from "@routes";

// Route maps based on entity type for CRM Team sourced directly from @routes
export const CRM_TEAM_ROUTES = {
  campaign: {
    base: CRUD_CAMPAIGN_CRM_TEAM,
    fetchById: `${CRUD_CAMPAIGN_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_CAMPAIGN_CRM_TEAM_BY_CAMPAIGN_ID,
    idKey: "campaignId",
  },
  inquiry: {
    base: CRUD_INQUIRY_CRM_TEAM,
    fetchById: `${CRUD_INQUIRY_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_INQUIRY_CRM_TEAM_BY_INQUIRY_ID,
    idKey: "inquiryId",
  },
  lead: {
    base: CRUD_LEAD_CRM_TEAM,
    fetchById: `${CRUD_LEAD_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_LEAD_CRM_TEAM_BY_LEAD_ID,
    idKey: "leadId",
  },
  prospect: {
    base: CRUD_PROSPECT_CRM_TEAM,
    fetchById: `${CRUD_PROSPECT_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_PROSPECT_CRM_TEAM_BY_PROSPECT_ID,
    idKey: "prospectId",
  },
  opportunity: {
    base: CRUD_OPPORTUNITY_CRM_TEAM,
    fetchById: `${CRUD_OPPORTUNITY_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_OPPORTUNITY_CRM_TEAM_BY_OPPORTUNITY_ID,
    idKey: "opportunityId",
  },
  contact: {
    base: CRUD_CONTACT_CRM_TEAM,
    fetchById: `${CRUD_CONTACT_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_CONTACT_CRM_TEAM_BY_CONTACT_ID,
    idKey: "contactId",
  },
  "customer-account": {
    base: CRUD_ACCOUNT_CRM_TEAM,
    fetchById: `${CRUD_ACCOUNT_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_ACCOUNT_CRM_TEAM_BY_ACCOUNT_ID,
    idKey: "customerAccountId",
  },
  account: {
    base: CRUD_ACCOUNT_CRM_TEAM,
    fetchById: `${CRUD_ACCOUNT_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_ACCOUNT_CRM_TEAM_BY_ACCOUNT_ID,
    idKey: "customerAccountId",
  },
  customer: {
    base: CRUD_CUSTOMER_CRM_TEAM,
    fetchById: `${CRUD_CUSTOMER_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_CUSTOMER_CRM_TEAM_BY_CUSTOMER_ID,
    idKey: "customerId",
  },
  contract: {
    base: CRUD_CONTRACT_CRM_TEAM,
    fetchById: `${CRUD_CONTRACT_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_CONTRACT_CRM_TEAM_BY_CONTRACT_ID,
    idKey: "contractId",
  },
  order: {
    base: CRUD_ORDER_CRM_TEAM,
    fetchById: `${CRUD_ORDER_CRM_TEAM}/fetch-by-id`,
    byEntityId: GET_ORDER_CRM_TEAM_BY_ORDER_ID,
    idKey: "orderId",
  },
};

// Default fallback routes
export const DEFAULT_CRM_TEAM_ROUTES = {
  base: CRUD_CRM_TEAM,
  fetchById: `${CRUD_CRM_TEAM}/fetch-by-id`,
};

const ACCOUNT_TYPE_ALIASES = new Set([
  "customeraccount",
  "customer-account",
  "account",
]);

const CRM_TEAM_ENTITY_RULES = [
  { type: "contract", keys: ["contractId", "forContract"] },
  {
    type: "customer-account",
    keys: ["customerAccountId", "accountId", "forAccount"],
  },
  { type: "contact", keys: ["contactId", "forContact"] },
  { type: "opportunity", keys: ["opportunityId", "forOpportunity"] },
  { type: "lead", keys: ["leadId", "forLead"] },
  { type: "campaign", keys: ["campaignId", "forCampaign"] },
  { type: "inquiry", keys: ["inquiryId", "forInquiry"] },
  { type: "prospect", keys: ["prospectId", "forProspect"] },
  { type: "customer", keys: ["customerId", "forCustomer"] },
  { type: "order", keys: ["orderId", "forOrder"] },
];

export const normalizeCrmTeamType = (type) => {
  if (!type || typeof type !== "string") {
    return null;
  }
  const cleanType = type.toLowerCase().trim();
  if (ACCOUNT_TYPE_ALIASES.has(cleanType)) {
    return "customer-account";
  }
  return cleanType;
};

export const resolveCrmTeamEntityType = (data) => {
  if (!data || typeof data !== "object") {
    return null;
  }

  const explicitType =
    data?.entityType ||
    data?.targetEntity ||
    data?.type ||
    data?.entity;

  const normalized = normalizeCrmTeamType(explicitType);
  if (normalized && CRM_TEAM_ROUTES[normalized]) {
    return normalized;
  }

  for (const rule of CRM_TEAM_ENTITY_RULES) {
    for (const key of rule.keys) {
      if (data[key] !== undefined && data[key] !== null) {
        return rule.type;
      }
    }
  }

  return null;
};

export const getCrmTeamRoutesByType = (type) => {
  const normalizedType = normalizeCrmTeamType(type);
  if (normalizedType && CRM_TEAM_ROUTES[normalizedType]) {
    return CRM_TEAM_ROUTES[normalizedType];
  }
  return DEFAULT_CRM_TEAM_ROUTES;
};

export const getCrmTeamRouteByType = (type, actionType = "base") => {
  const routes = getCrmTeamRoutesByType(type);
  switch (actionType) {
    case "getCrmTeam":
      return routes?.byEntityId || routes?.base;
    case "addCrmTeam":
    case "updateCrmTeam":
    case "deleteCrmTeam":
    default:
      return routes?.base;
  }
};

export const getCrmTeamRoute = (data, actionType = "base") => {
  const resolvedType = resolveCrmTeamEntityType(data);
  return getCrmTeamRouteByType(resolvedType, actionType);
};
